import React from "react";
import Main from "./View/Main/routes";
import Company from "./View/Company/routes";
import Notice from "./View/Notice/routes";
import Business from "./View/Business/routes";
import Promotion from "./View/Promotion/routes";
import Recruit from "./View/Recruit/routes";
import Management from "./View/Management/routes";

let routes = {};
routes["main"] = Main;
routes["notice"] = Notice;
routes["company"] = Company;
routes["business"] = Business;
routes["promotion"] = Promotion;
routes["recruit"] = Recruit;
routes["management"] = Management;

export default routes;
